/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientName/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PatientName({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue/AppointmentQueue/Content/Appointment/PatientName"
  
}) {
let eventAppointmentPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.person',
})
let settingsHipaaValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'hipaa',
})
let constantData = 'short'
let aggregateData = fromAggregate.basicPatientInformation(eventAppointmentPatientPersonValueData, settingsHipaaValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 whiteSpace="nowrap"
 overflowX="hidden"
 overflowY="hidden"
 textOverflow="ellipsis"
 display="inline-block"
 data="event.appointment.patient.person"
 data="settings.hipaa"
 data="'short'"
 aggregate="/Data/aggregate.js basicPatientInformation"
 text={aggregateData}
 weight="medium"
/>
{children}
</React.Fragment>)
}